export default __webpack_public_path__ + "static/rsz_rzethon-1e75a74668f4515c5c3404ba1ffde9fb.png";